import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17bc404c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Stai aggiungendo un nuovo strumento a questo dipendente", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Aggiungi strumenti al dipendente", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "content overflow-hidden" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_6 = { class: "left-content" }
const _hoisted_7 = { class: "searchbar flex" }
const _hoisted_8 = { class: "tool-item-list overflow-y-scroll custom-scrollbar" }
const _hoisted_9 = { class: "working-site-name font-bold" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "right-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-description-voices grid grid-cols-3 gap-4 py-3 mt-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "pl-3" }, "Primo campo"),
  /*#__PURE__*/_createElementVNode("h4", { class: "pl-3 text-center" }, "Secondo campo"),
  /*#__PURE__*/_createElementVNode("div", { class: "delete" })
], -1))
const _hoisted_13 = { class: "added-tool-item-list overflow-y-scroll custom-scrollbar" }
const _hoisted_14 = { class: "working-site-name font-bold" }
const _hoisted_15 = { class: "chief-checkbox text-center container" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _hoisted_1
    ]),
    h2: _withCtx(() => [
      _hoisted_2
    ]),
    h3: _withCtx(() => [
      (_ctx.isShowingStep1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Step 1 di 1"))
        : _createCommentVNode("", true)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Annulla")
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAdd()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Aggiungi")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "text px-4 py-3 flex-grow tool-item-filter-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toolItemsSearchFilter) = $event)),
                type: "text",
                placeholder: "Inserisci il nome dello strumento"
              }, null, 512), [
                [_vModelText, _ctx.toolItemsSearchFilter]
              ]),
              _createElementVNode("button", {
                class: "button text-primary flex-none font-bold find",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch()))
              }, "Cerca")
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unselectedToolItems, (unselectedUser) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tool-item",
                  key: unselectedUser.id
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(unselectedUser.primaryField) + " - " + _toDisplayString(unselectedUser.secondaryField), 1),
                  _createElementVNode("button", {
                    class: "add-working-site font-bold",
                    onClick: ($event: any) => (_ctx.addUser(unselectedUser.id))
                  }, "Aggiungi", 8, _hoisted_10)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedToolItems, (selectedUser) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tool-item grid grid-cols-3",
                  key: selectedUser.id
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(selectedUser.primaryField), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(selectedUser.secondaryField), 1),
                  _createElementVNode("button", {
                    class: "remove-WorkingSite font-bold",
                    onClick: ($event: any) => (_ctx.removeUser(selectedUser.id))
                  }, "Elimina", 8, _hoisted_16)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}